import { coreApi } from '../../utils/axios';

export interface PrescribingProtocol {
  condition_id: string;
  url: string;
}

export interface User {
  _id: string;
  user_id: string;
  username: string;
  forename: string;
  surname: string;
  roles: string[];
  is_verified: boolean;
  date_created: number;
  login_verified: boolean;
  nmc_number?: string;
  gphc_number?: string;
  address?: string;
  clinic_name?: string;
  postcode?: string;
  registration_body?: string;
  telephone?: string;
  prescribing_protocols?: PrescribingProtocol[] | null;
}

export interface GetUsersResponse {
  data: User[];
  error?: {
    code: string;
    message: string;
  };
}

export const searchUserByEmail = async (email: string) => {
  const response = await coreApi.get<GetUsersResponse>(`/users?username=${encodeURIComponent(email)}`);
  return response.data;
};

export const getUserById = async (userId: string) => {
  const response = await coreApi.get<{ data: User[] }>(`/users/${userId}`);
  return response.data.data[0];
};
